<template>
  <v-card style="padding: 1rem">
    <h2 class="mb-4">Posting</h2>
    <div class="p-4">
      <div style="width: fit-content; margin: 0 auto">
        <v-date-picker v-model="posting_date" type="month" landscape />
      </div>
    </div>
    <v-card-actions>
      <v-spacer />
      <v-btn :disabled="process" :loading="process" color="primary" text @click="posting()"
        >Posting</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from '@/libs/axios';
export default {
  name: 'ModalContentPosting',
  data() {
    return {
      posting_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).t,
      process: false,
    };
  },
  props: {
    onclose: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    async posting() {
      try {
        this.process = true;
        const [year, month] = this.posting_date.split('-');

        await axios.post('/utility/posting', {
          month: parseInt(month),
          year: parseInt(year),
        });

        this.onclose();

        alert('Posting successfuly !');
      } catch (error) {
        alert(`Fail posting ${error.response.data.details}`);
      } finally {
        this.process = false;
      }
    },
  },
};
</script>
